import { render, staticRenderFns } from "./KanriInvoiceItemsView.vue?vue&type=template&id=d1d688d2&scoped=true&"
import script from "./KanriInvoiceItemsView.vue?vue&type=script&lang=ts&"
export * from "./KanriInvoiceItemsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d688d2",
  null
  
)

export default component.exports